import React, { createContext, useContext, useState, useCallback } from 'react';
import is from '@/i18n/is.json';
import en from '@/i18n/en.json';

const translations = { is, en };

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('rektra_lang') || 'is');

  const switchLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem('rektra_lang', newLang);
    // Persist language preference to backend
    const token = localStorage.getItem('auth_token');
    if (token) {
      fetch('/api/auth/language', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ language: newLang }),
      }).catch(() => {});
    }
  }, []);

  // Initialize from user's stored preference (called by AuthContext after login)
  const initLang = useCallback((userLang) => {
    if (userLang && (userLang === 'is' || userLang === 'en')) {
      setLang(userLang);
      localStorage.setItem('rektra_lang', userLang);
    }
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] ?? translations.is[key] ?? key;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, language: lang, switchLang, initLang, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
